export const COMMANDER = 'Commande';
export const AFFECTER_DANS_RESEAU = 'Reseau';
